<template>
  <div class="blank_Page">
    <img class="blank_Logo" alt="Audemars Piguet" src="/img/logos/fullmark_white.png" />
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {

  }
}
</script>
